import React from "react";
import headshot from "../../assets/headshot.png";
import { Link } from "react-router-dom";
import {
  Container,
  TitleWrapper,
  Title,
  SubTitle,
  GradientText,
} from "./styles";

const Header: React.FC = () => (
  <Container>
    <Link to="/" className="link">
      <TitleWrapper>
        <Title>
          <GradientText>Isaac Barcroft</GradientText>
        </Title>
        <SubTitle>Software Engineer</SubTitle>
      </TitleWrapper>
    </Link>
    <Link to="/" className="link">
      <img
        src={headshot}
        className="App-logo"
        alt="head shot"
        width="150px"
        height="150px"
      />
    </Link>
  </Container>
);

export default Header;
